{
	"title": "Colofon",
	"backTitle": "Terug",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Duitsland"
		},
		"contact": {
			"telephone": "Telefoon: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "E-mail: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Statutaire zetel van het bedrijf: Heidelberg",
			"commercialRegister": "Handelsregister: Mannheim, HRB 741878",
			"managingDirectors": "Directie:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
